import { createI18n } from "vue-i18n";
import { en } from "@/translations/en";
import { fr } from "@/translations/fr";
import { es } from "@/translations/es";
import { de } from "@/translations/de";

const messages = {
  en,
  fr,
  es,
  de,
};

const datetimeFormats = {
  en: {
    long_month: {
      year: "numeric",
      month: "long",
    },
    numeric_full: {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    short_time: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short_time_second: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    long_date: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    },
    hour: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  fr: {
    long_month: {
      year: "numeric",
      month: "long",
    },
    numeric_full: {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    short_time: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short_time_second: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },

    long_date: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    },
    hour: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  es: {
    long_month: {
      year: "numeric",
      month: "long",
    },
    numeric_full: {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    short_time: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short_time_second: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },

    long_date: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    },
    hour: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  de: {
    long_month: {
      year: "numeric",
      month: "long",
    },
    numeric_full: {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    short_time: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    short_time_second: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },

    long_date: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    },
    hour: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
};

export const i18n = createI18n({
  locale: navigator.language.split("-")[0].toLowerCase(),
  fallbackLocale: "fr",
  messages,
  datetimeFormats,
});
